export default {
  data() {
    return {
      formCharGeneral: {
        act: true,
        mod: "D1", // version of data model
        ver: "0.0", // version of model
        fdid: "", // facility did
        ftag: "", // facility tag
        fname: "", // facility name
        fidg: "", // facilty idg
        fshort: "", // facility idg
        reach: "comp", // facility / company wide / of company wide
        region: "", // region limit AU / EL / etc
        code: "", // code for this unqiue to facility
        goal: "", // why do maintenance what is the end target
        assess: "", // technical assessment
        scope: "", // limits of stratgey / work (what is in and out)
        driver: "", // business driver and justification
        access: "", // operational access
        com: "", // comment
        dis: "", // primary technical discipline, like Electrical
        sum: "", // summary
        status: "", // generally status is used
        des: "", // descripton
        complx: "", // level of complexity
        impl: "", // implementaion type engineering
        time: "", // teomprary / permamanet item
        type: "", // type of maintenance plan
        types: "" // sub type
      },
      formCharAccess: {
        type: "ART1", // access request type
        did: "", // access object (Company or Facility) DID
        title: "", // access object title
        idg: "", // access object idg
        id: "", // access object id
        tag: "", // access object tag
        uidg: "", // user id (access requestor)
        udid: "", // user did
        utitle: "", // user title
        uemail: "" // user email
      },
      formCharDocumentLog: {
        did: "", // object under review
        com: "", // comment for log user for user only
        title: "",
        idg: "",
        id: "",
        tag: "",
        tagd: "",
        tags: "",
        cdid: "",
        fdid: "",
        tverb: "", // text action work
        tnoun: "" // text noun verb
      },
      formCharNotification: {
        des: "", // description
        dis: "", // discipline
        type: "", // type of notification
        org: "", // origin of notification
        stat: false, // status false (not complete), status true = complete
        vm: "", // virtual map
        x: "", // x coordinate of virtual map
        y: "", // y coordinate of virtual map
        z: "" // z coordinate of virtual map
      },
      formCharRiskAssessment: {
        theme: "", // other
        reach: "", // penetration of risk assessment
        type: "", // type of risk assessment
        cond: "", // risk timing / under what condition
        cat: "", // category
        com: "", // comments // conext of risk assessment
        cons: "", // consequence
        like: "", // liklekhood
        comp: "", // compliance risk
        cause: "", // potentail causes for the risk
        sum: "", // risk summary and closeing comments
        bar: "", // barriers that can fbe take credit for this outcome
        bars: "", // barriers that can be take credit for this outcome
        cont: "", // controls, baseline, or more
        conts: "", // controls, status
        ref: "" // risk reference
      },
      formCharRisk: {
        comp: "", // under what condution
        cond: "", // under what condution
        bar: "", // barrier comments
        barr: "", // barrier reference
        bars: "", // barrier sattus
        contr: "", // risk control reference
        conts: "", // risk control status
        des: "", // desciption of risk scenario
        dis: "", // risk ownership discipline
        long: "", // risk longevity
        ref: "", // risk assessment reference
        theme: "", // incident
        time: "", // cyclical
        type: "",
        rec: "", // recommendation
        system: "", // systemic issue
        reach: "", // scope of the investigation
        spons: "", // invetsigatuon sponsor
        risk: "", // preliniary risk assessment
        rate: "", // risk rateing
        method: "General",
        out: "Weakness", // investigation not started
        scope: "", // scope description
        impact: "", // impact description
        isoc: "", // impact socail
        ienv: "", // impact envirnment
        ibus: "", // impact business
        ihse: "", // impact hse
        irep: "", // impact reputtaion
        ifin: "", // impact finace / asset
        vm: "", // virtual map
        x: "", // x coordinate of virtual map
        y: "", // y coordinate of virtual map
        z: "" // z coordinate of virtual map
      },
      formCharRiskAnalysis: {
        cat: "", // category prior
        com: "", // comments
        cons: "", // consequence
        like: "", // liklekhood
        risk: "", // current risk
        rate: "", // current rating
        calc: "", // risk calculation Conseq x Liki
        comp: "", // compliance risk
        sum: "", // risk summary and closeing comments
        bar: "", // barriers that can be take credit for this outcome
        bars: "", // barriers that can be take credit for this outcome
        barr: "",
        contl: "", // controls, baseline, or more
        contlr: "",
        contls: "" // controls, status
      },
      formCharEquipment: {
        dis: "", // engineering discipline // drop down
        code: "", // code
        reg: "", // register
        cat: "", // class type // Motor /  Valve
        type: "", // sub type // DC Motor / Relief Valve
        cert: "", // engineering cert
        spec: "", // techspecifications
        comm: "", // commissoning
        const: "", // constructions
        des: "", // engineering commnt
        maint: "", // maintenance comments
        consum: "", // maint/ consumables
        recycle: "", // recycle option
        hand: "", // special care
        repair: "", // repair options
        req: "", // min maintenance requirements
        rel: "", // relaibility measure
        avail: "", // avaialbiliy
        util: "", // reliability metrics
        mttf: "", // reliability metrics
        mtbf: "", // reliability metrics
        mttr: "", // reliability metrics
        design: "", // design standard
        perf: "", // performance standard
        ops: ""
      }, // Detail level attach to others
      formCharEngineering: {
        des: "", // desciption of engineering request
        rec: "R0", // recommendation
        reach: "Company", // scope of the engineering stidy
        spons: "Management", // invetsigatuon sponsor
        risk: "Low", // risk of project
        theme: "Site", // projet theme
        dis: "General", // discipline eng
        close: "", // stidy investigation and close comments
        method: "Basic",
        driver: "General",
        life: "25",
        time: "Perm",
        ref: "", // additional reference
        rev: "Peer", // review method
        pri: "P5",
        out: "C0", // investigation not started
        scope: "", // scope description
        impact: "Not assessed.", // impact description
        isoc: "NA", // impact socail
        ienv: "NA", // impact envirnment
        ibus: "NA", // impact business
        ihse: "NA", // impact hse
        irep: "NA", // impact reputtaion
        ifin: "NA", // impact finace / asset
        carba: 0, // carbon acual
        carbe: 0, // carbon estimate
        carbu: "kg", // carbon unit
        carbi: "Ops",
        costa: 0, // cost actual
        coste: 0, // cost estimate
        costl: 1000, // cost lifecycel
        costu: "AUD", // cost unit
        vm: "", // virtual map
        x: "", // x coordinate of virtual map
        y: "", // y coordinate of virtual map
        z: "" // z coordinate of virtual map
      },
      formCharReport: {
        des: "", // desciption of technical report
        dis: "General", // discipline eng
        close: "", // report close comments
        rec: "R0", // recommendation
        out: "C0", // investigation not started
        theme: "", // ops / eneg / maint
        life: "", // lifecyle
        type: "", // type of inspection / test report
        scope: "", // technical scope description (copy)
        stat: false, // status (false = not published / true = published)
        vm: "", // virtual map
        x: "", // x coordinate of virtual map
        y: "", // y coordinate of virtual map
        z: "" // z coordinate of virtual map
      },
      formCharWork: {
        close: "", // close out comments
        type: "", // type of work
        pri: "P5", // priority
        scope: "", // work scope
        driver: "Reliability", // driver
        cond: "OK", // as found condition
        ores: "", // team owner resourceing
        oplan: "", // plan team
        oeng: "", // engineerin team
        oops: "", // ops support
        oexe: "", // execute team
        des: "", // general description
        comp: "", // compliance type
        dis: "", // technical discipline
        theme: "", // work theme
        ref: "", // referene
        key: "", // common key
        out: "", // outcome of work
        qa: "", // quality assurance
        escal: "NA", // escalation potential
        plan: "", // work plan comments
        risk: "Medium", // executio risk
        shift: "D", // work shift requirements
        impact: "", // impact description
        isoc: "", // impact socail
        ienv: "", // impact envirnment
        ibus: "", // impact business
        ihse: "", // impact hse
        irep: "", // impact reputtaion
        ifin: "", // impact finace / asset
        vm: "", // virtual map
        x: "", // x coordinate of virtual map
        y: "", // y coordinate of virtual map
        z: "" // z coordinate of virtual map
      },
      formCharAction: {
        active: "Study", // activity / action word
        owner: "Site", // action owner
        scope: "", // scope
        spons: "Management", // sponsor for action
        reach: "Facility", // how far reaching is the action
        out: "C0", // outcome of indicent investigation
        rec: "R0", // recommendation
        type: "", // action type:
        resrc: "", // resource type
        just: "", // justificatoin for action
        close: "", // close out comments for action
        cont: "", // risk control if applicable
        impact: "Site", // impact on busienss
        pri: "P5",
        theme: "", // theme
        ref: "" // reference id, project, ops etc
      },
      formCharCompany: {
        epri: "", // this is primary email
        esec: "",
        ppri: "", // this is primary phone
        psec: "",
        lcountry: "Australia", // country // where you work
        lstate: "", // state // where you work
        lcity: "", // address .// address stree stec.
        lpost: "", // location post code
        ladd: "", // address .// address stree stec.
        ldes: "", // description of location
        llink: "", // location link
        area: "", // area of business
        struct: "", // item structure
        abn: "", // aus business number
        acn: "", // aus itemany number
        name: "", // legal name
        names: "", // short
        web: "", // wesbite
        qr: "", // qr code
        type: "", // indysrty
        des: "", // quick desicrion about ops
        mis: "", // company mission
        val: "", // company values
        stry: "" // company strategy
      },
      formCharFacility: {
        epri: "", // this is primary email
        esec: "",
        ppri: "", // this is primary phone
        psec: "",
        lcountry: "Australia", // country // where you work
        lstate: "", // state // where you work
        lcity: "", // address .// address stree stec.
        lpost: "", // location post code
        ladd: "", // address .// address stree stec.
        ldes: "", // description of location
        llink: "", // location link
        manage: "", // item sructir
        own: "", // ownership of the facility
        loc: "", // location mobile or offshore
        site: "Free", // site access
        risk: "Medium", // operaing risk
        out: "Production", // output
        reg: "", // reguation o rlicence
        work: "Management", // work permit
        scope: "Production as per the target.", // operations scope
        spons: "Operations", // operations care and custody
        kpi: "", // KPI
        type: "", // indysrty
        theme: "", // secondary type;
        qr: "", // qr code
        des: "", // quick desicrion about ops / capability
        obj: "Safe and reliable operations.", // objective and purpose of facility
        impact: "Moderate impact on local community.", // impact description
        isoc: "", // impact socail
        ienv: "", // impact envirnment
        ibus: "", // impact business
        ihse: "", // impact hse
        irep: "", // impact reputtaion
        ifin: "" // impact finace / asset
      },
      formCharAsset: {
        isol: "ISO6", // isolation level
        isot: "", // isolation type
        isok: "", // isoltion key
        accl: "AL1",
        acct: "AN1",
        code: "", // engineering code
        str: "RTF", // maint strategy
        maint: "", // maint. description
        keym: "", // maintenance key
        keyi: "", // operational key
        keyo: "", // iso.key
        req: "", // fmaintennce requirements
        map: "", // localtion map to identify asset
        grid: "", // grid to indety asset
        link: "", // link to other webiste etc
        list: "", // engineering register or list
        cert: "", // certificate
        area: "", // area in facility
        crit: "", // business criticality
        ref: "", // business imp
        design: "1oo1",
        unit: "", // item area
        sec: "", // plants section
        secs: "", // plan sub sections
        sys: "", // system
        syss: "", // sub system
        cycle: "O1", // operating cycle
        mode: "OM1",
        make: "",
        model: "",
        type: "TA4",
        ser: "", // serial number
        eng: "", // technical and / or engineering description
        mob: "", // mobility
        qr: "", // qr code
        des: "", // quick desicrion about ops / capability,
        vm: "", // virtual map
        x: "", // x coordinate of virtual map
        y: "", // y coordinate of virtual map
        z: "" // z coordinate of virtual map
      },
      formCharUser: {
        nfirst: "", // first name
        nlast: "", // last name or surname
        nmid: "", // middle middle
        npref: "", // prefered name in the app. (normally + first + last name)
        ppri: "", // this is primary phone
        psec: "", // seconday email
        epri: "", // this is primary email
        esec: "", // secondary emial
        lcountry: "Australia", // country // where you work
        lstate: "", // state // where you work
        lcity: "", // address .// address stree stec.
        lpost: "", // location post code
        ladd: "", // address .// address stree stec.
        ldes: "", // description of location
        rpos: "", // position, example Senior Engineer
        rtype: "", // electrican
        rid: "", // position id
        rdes: "", // position description
        rct: "", // role commpany employer name (legal name)
        rcdid: "", // roles company employer id
        rft: "", // role commpany employer name (legal name)
        rfdid: "" // roles company employer id
      },
      formCharAttachment: {
        data: "", // type of data image etc
        com: "", // attachement comment
        type: "", // type of attachment, opinion, drawings etc
        imp: "", // level of importance, info or supporting evidence
        link: "", // http or other link, but no files.
        stg: "", // storage link
        crit: false, // critical attachment
        theme: "", // theme
        ref: "" // reference id, project, ops etc
      },
      formCharOrder: {
        dis: "", // technical discipline dispcline
        type: "", // type of order (Service or Parts)
        theme: "", // transaction
        typet: "Truck", // type of order (Service or Parts)
        typep: "", // payment type
        prio: "P5", // order priority
        prit: "P5", // transport prioriy
        statt: "Add", // status of transport
        statp: "Add", // status of payment
        qty: 1,
        des: "", // description of order scope
        order: "",
        pay: "", // payment commets
        payd: "", // payment deposit
        paya: "", // payment adjustment
        per: 1, // persons
        hrs: 1, // hours
        rate: 1, // rate assigned
        shift: "", // work shift arrangement
        add: "", // transprt address
        trans: "", // transport comments
        qa: "NR", // quality check after transportation
        costu: "AUD", // cost unit
        costt: 0, // transport cost
        carbt: 0, // transport carbon
        costo: 0, // cost of order
        carbo: 0, // carbon of order
        carbu: "kg", // carbon units
        mob: "New", // mobilisation status
        goods: "", //type of good transported
        haz: "", // hazards during trnasport
        cons: "", // consingment note requested
        batch: "", // batch
        ordn: "", // order name,
        ordt: "", // order type type
        ordi: "", // order id
        ordq: "", // order quantaty
        ordc: "", // additional  comment
        partq: "", // part quty
        vt: "", // vendor title
        vtt: "", // vendor title for transport
        vid: "", // vendor id
        vidt: "", // vendor id for transport service
        vdid: "", // vendor did
        vdidt: "", // vendor did for transport
        vm: "", // virtual map
        x: "", // x coordinate of virtual map
        y: "", // y coordinate of virtual map
        z: "" // z coordinate of virtual map
      },
      formCharParts: {
        qty: "0",
        unit: "",
        type: "",
        cost: "0", // cost estimate
        costu: "AUD",
        carb: "", // carbon
        carbu: "kg",
        dis: "",
        com: "",
        eta: "",
        add: "",
        src: "",
        ot: "", // order title
        oidg: "", // generated id
        odid: "", // order did
        oid: "", // order id
        midg: "", // material id if imported
        mid: "", // material id if imported
        mdid: "", // material did
        mt: "", // material title
        status: ""
      },
      formCharLimit: {
        type: "",
        dis: "",
        limid: "",
        limval: "",
        com: ""
      },
      formCharResources: {
        hrs: "0",
        hrsa: "0", // actual
        rate: "100",
        type: "",
        cost: "0", // cost
        costu: "AUD",
        carb: "0", // carbon for transport
        carbu: "kg",
        dis: "",
        com: "",
        eta: "",
        per: "1", // persons needed
        oid: "", // order id
        ot: "", // order title
        oidg: "", // order idg
        odid: "", // order did
        status: "" // resource request
      },
      formCharAnalysis: {
        rate: "0.1",
        type: "",
        dis: "",
        com: "",
        cond: "",
        cause: "",
        effect: "",
        patt: "",
        detect: ""
      },
      formCharMaintActivity: {
        type: "", // typ
        dis: "", // discipline
        com: "", // comment
        driver: "", // driver
        freq: "", // frequency
        owner: "", // who is doing it
        model: "", // model
        method: "", // method
        unit: "", // units of frequenct
        coste: "", // to do it
        costu: "AUD",
        carbe: "", // carbon
        carbu: "kg",
        cond: "", // condition
        comp: "", // compliance or regulatory standards
        scope: "",
        fail: "",
        imp: "" // imp on resources
      },
      formCharInventory: {
        type: "", // typ
        crit: "", // ciriticality
        haz: "", // hazards
        com: "", // change is stock level
        owner: "", // owner (code)
        spons: "", // additional info for sponsor (onwer)
        stomin: 0, // minin order
        stomax: 0, // stooage capaicty
        stoord: 0, // minin order
        stocur: 0, // stooage capaicty
        ibound: "", // inbound instructions
        obound: "", // outbound instructions
        des: "" // desciption of storage =
      },
      formCharEngineeringResults: {
        type: "", // typ
        dis: "", // discipline
        com: "", // comment
        own: "", // responsible for result
        out: "", // outcome of result
        method: "", // method
        ref: "", // standard
        cond: "", // condition
        spec: "", // test specifications
        pass: "", // pass fail criteria
        cat: "", // category
        test: "", // outcome / numeric
        result: "", // test or inspection result
        rhi1: "", // result high 1
        rhi2: "", // result high 2
        rlo1: "", // result low 1
        rlo2: "", // result low 2
        rout1: "", // inspection warning
        rout2: "", // inspectyion fault
        unit: "", // unit for the result
        status: "" // status
      },
      formCharMaintCall: {
        call: "",
        cost: "",
        costu: "AUD",
        carb: "",
        carbu: "",
        status: "",
        comp: "",
        close: "",
        out: "",
        qa: "",
        type: "",
        theme: "",
        pri: ""
      },
      formCharPermit: {
        type: "",
        dis: "",
        com: "",
        link: "",
        perid: "",
        perdid: "", // order
        pert: "", // per title
        status: ""
      },
      formCharTask: {
        type: "Inspect",
        theme: "P",
        dis: "",
        com: "", // comment for completed task
        req: "", // requirmenet what is needed
        close: "", // close out comments
        resr: "",
        part: "",
        ref: "", // tech reference
        hrs: "1", // estimate
        hrsa: "0", // actial
        per: "1",
        status: ""
      },
      formCharPlan: {
        type: "", // type of attachment, opinion, drawings etc
        time: "Annual", // cycle of budgte
        des: "", // description / requirements
        reach: "Facility",
        spons: "Management", // sponsor
        scope: "",
        theme: "Operations", // theme
        driver: "Protect", // driver, why
        dis: "Business", // discipline, electrical etc
        out: "C0", // outcome
        rec: "R0", // recommendation
        close: "", // close out
        impact: "", // impact description
        isoc: "NA", // impact socail
        ienv: "NA", // impact envirnment
        ibus: "NA", // impact business
        ihse: "NA", // impact hse
        irep: "NA", // impact reputtaion
        ifin: "NA", // impact finace / asset
        shift: "8", // plan shift duration
        perday: "1", // plan shift day
        derate: "0.75", // plan factor
        free: "0", // plan factor
        parts: "NA", // readiness
        resr: "NA", // readiness
        hire: "NA", // hire equipment
        tools: "NA", // tools equipment
        status: "", // readiness
        ready: "", // readiness comments
        item: ""
      },
      formCharMaterial: {
        model: "", // oem model, specific product
        make: "", // make // brand of car
        place: "", // place of manufatuer
        cert: "NA", // certfication requirment
        certs: "", // certfication additional info
        nser: "", // serial numer
        npart: "", // part number
        spec: "", // technical specfications
        repair: "", // repair options
        recyle: "", // recycle options
        carba: 0, // carbon acual
        carbe: 2.5, // carbon estimate
        carbu: "kg", // carbon unit
        costa: 0, // cost actual
        coste: 50, // cost estimate
        costu: "AUD", // cost unit
        des: "", // material general descriptiopn
        pkgwht: "", // package weight
        pkgsize: "", // package size
        unwht: "", // unit weight
        unsize: "", // unit size, dimensions
        unit: "",
        unpkg: "", // units per package
        unload: "", // unload instrcuitions
        load: "", // load instructions
        care: "", // care
        store: "",
        stotyp: "", // type
        stotra: "", // storeage transport
        maint: "", // maintenance requirements
        hand: "", // handling requirements
        lead: "3M", // lead time of the part
        spare: 0,
        avail: "", // material availability
        supp: "", // local supplier
        trans: "", // transport comments
        order: "", // order comments
        eng: "" // engineering requirements
      },
      formCharMaintPlan: {
        call: "", // call description scope
        last: "", // last call
        type: "Area", // type of Work
        types: "T1", // type of work order
        theme: "Inspect", // work theme
        batch: "", // batch id
        pri: "P5", // priority
        key: "", // isolation or sexecution key
        scope: "", // work scope
        iso: "Asset", // isolstion stratedy
        ref: "", // reference
        ores: "", // team owner resourceing
        oplan: "", // plan team
        oeng: "", // engineerin team
        oops: "", // ops support
        oexe: "", // execute team
        comp: "", // compliance type
        impact: "", // impact description
        isoc: "", // impact socail
        ienv: "", // impact envirnment
        ibus: "", // impact business
        ihse: "", // impact hse
        irep: "", // impact reputtaion
        ifin: "", // impact finace / asset
        des: "", // general descrioption
        escal: "Trip", // escalation potential
        prep: "0.5",
        status: "Created",
        risk: "L", // executio risk
        shift: "A" // work shift requirements
      },
      formCharMaintStrategy: {
        relt: "", // relaibility trips (failures)
        rela: "", // relaibility actual
        rele: "", // relaibility estimate
        relu: "%", // reliability units
        impa: "", // impact actual
        impe: "", // impact estimate
        impt: "", // imapct type
        impu: "pa", // impact unit
        coste: "", // cost estimte
        costa: "", // cost actul
        costu: "AUD", // cost budget
        carbe: "", // carbon estimate
        carba: "", // carbon actual
        carbu: "kg", // carbon unit
        driver: "",
        target: "",
        type: "", // type of Work
        pri: "P5", // priority
        scope: "", // work scope
        dis: "", // technical discipline
        theme: "", // work theme
        reach: "", // scope of the investigation
        spons: "", // invetsigatuon sponsor
        impact: "", // impact description
        isoc: "", // impact socail
        ienv: "", // impact envirnment
        ibus: "", // impact business
        ihse: "", // impact hse
        irep: "", // impact reputtaion
        ifin: "" // impact finace / asset
      },
      formCharBudget: {
        type: "", // type of attachment, opinion, drawings etc
        time: "Annual", // cycle of budgte
        des: "", // description / requirements
        reach: "Facility",
        spons: "Management", // sponsor
        scope: "",
        carba: 0, // carbon acual
        carbe: 0, // carbon estimate
        carbu: "kg", // carbon unit
        costa: 0, // cost actual
        coste: 0, // cost estimate
        costu: "AUD", // cost unit
        theme: "Operations", // theme
        driver: "Protect", // driver, why
        dis: "Business", // discipline, electrical etc
        ref: "", // reference id, project, ops etc
        out: "C0", // outcome
        rec: "R0", // recommendation
        close: "" // close out
      },
      formCharHazard: {
        cond: "", // under what condition
        contc: "", // control comments
        conte: "", // control effectivness
        conta: "", // control assurance
        des: "", // hazard description
        dis: "", // discipline, electrical etc
        reach: "", // level
        theme: "" // theme
      },
      formCharProcedure: {
        des: "", // procedure desciption
        spons: "", // procedure sponsor
        scope: "", // scoep
        reach: "", // applicabl
        type: "", // type of attachment, opinion, drawings etc
        complx: "", // complexity of procedure
        cat: "", // categrory
        crit: "", // criticality
        dis: "", // theme did
        driver: "" // driver, why
      },
      formCharProgram: {
        des: "", // procedure desciption
        spons: "", // procedure sponsor
        scope: "", // scoep
        reach: "", // applicabl
        type: "General", // type of attachment, opinion, drawings etc
        cond: "Online", // categrory
        crit: "", // criticality
        dis: "Electrical" // theme did
      },
      formCharIncident: {
        des: "", // desciption of incidnet
        complx: "",
        rec: "R0", // recommendation
        system: "", // systemic issue
        reach: "", // scope of the investigation
        inde: "", // independce
        spons: "", // invetsigatuon sponsor
        risk: "", // preliniary risk assessment
        found: "", // as found condition
        cond: "", // under what condution
        cat: "", // incident // type / category
        theme: "", // incident
        dis: "", // discipline eng
        close: "", // investigation and close comments
        method: "Basic",
        out: "C0", // investigation not started
        scope: "", // scope description
        impact: "", // impact description
        isoc: "", // impact socail
        ienv: "", // impact envirnment
        ibus: "", // impact business
        ihse: "", // impact hse
        irep: "", // impact reputtaion
        ifin: "", // impact finace / asset
        vm: "", // virtual map
        x: "", // x coordinate of virtual map
        y: "", // y coordinate of virtual map
        z: "" // z coordinate of virtual map
      },
      formCharRole: {
        resp: "", // resposibilities / tasks of role
        icon: "", // icon assigned to this perosn
        dis: "", // technical or busienss discipline
        person: "Required", // is person assignment requird
        comp: "", // comp and training required for this task
        exp: "", // min level of exp required like Senior or Junior
        type: "", // type of role Approve or Orginator, etc
        theme: "", // theme of role saftey / technical / planning
        team: "", // team in the context of this doc
        teami: "", // team id in the conetx of this doc
        rank: 0, // ranking for logical lists, list of other for future
        crit: "Business", // critical role in success of business
        res: "", // resource internal or extrnal
        ref: "" // reference id, project, ops etc
      }
    };
  }
};
